import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "teammate-profile d-flex align-center" }
const _hoisted_2 = { class: "teammate-avatar-container" }
const _hoisted_3 = { class: "teammate-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.userState || _ctx.userState.status === 'loading')
      ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          class: "loader",
          type: "list-item-avatar"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Avatar, {
              class: "teammate-avatar",
              avatarID: _ctx.userState.profile.avatar
            }, null, 8, ["avatarID"])
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userState.profile.name), 1),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
  ]))
}